import { LoggerTags } from './constants/loggerTags';
import logToBackend from './logToBackend';

/**
 * Log CLS caused by an ad
 * You shouldn't call this manually; This is handled by <AdLayoutWatchdog />
 *
 * @param {Error} error - The error to log
 * @param {string} [pageUrl] - URL where the issue occurred
 * @param {string} [platform] - Platform type; 'mobile' or 'desktop' is expected
 * @param {number} [displayWidth] - Current display width, in px
 * @param {number} [offset] - Layout offset, in px
 * @param {string} [adUnitId] - Ad Unit ID
 * @param {string} [creativeId] - Ad Creative ID
 * @param {string} [lineItemId] - Ad Line Item ID
 */
const logAdCLSError = (
  pageUrl: string,
  platform: 'mobile' | 'desktop',
  displayWidth: number,
  offset: number,
  adUnitId: string,
  creativeId: string,
  lineItemId: string,
) => {
  logToBackend(LoggerTags.AD_CLS_ERROR, 'CLS', {
    pageUrl,
    platform,
    displayWidth,
    offset,
    adUnitId,
    creativeId,
    lineItemId,
  });
};

export default logAdCLSError;
